export default "__VITE_ASSET__Bc_ua2PU__"